import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import classname from 'classname';

import StreamForm from '../components/stream-form/main';

import isEmpty from 'lodash/isEmpty';

lessRequire('modules/streams/single/main.less');

const Main = renderViewsState(props => {
	const { intl } = props;
	const { landings, selectedOffer } = props.tableData;
	const className = {
		'font-proxima-nova-semibold': true
	};
	const isExternalOfferSelected = !isEmpty(selectedOffer) && !!selectedOffer.external_integration;
	const isAdditionalTabsHidden = !isExternalOfferSelected &&
		( isEmpty(selectedOffer) || !landings.paginated ||isEmpty(landings.paginated.data));

	const needPostbackLog = !isEmpty(selectedOffer)
		&& landings.paginated && !isEmpty(landings.paginated.data);
	return (
		<div className="stream-wrap container">
			<div className={`content-container ${props.isEditMode && !props.canEdit ? 'not-editable' : ''}`}>
				<div className="content-container__title">
					{ props.isEditMode ?
						<h2 className={classname({
							'font-proxima-nova-bold': true,
							'need-smaller': needPostbackLog
						})}>{intl('Редактировать поток')}</h2>
						: <h2 className="font-proxima-nova-bold">{intl('Создать поток')}</h2>
					}
					<div className="stream-wrap__switch header-switch">
						<div className="header-switch__links">
							<a href="#" onClick={e => {
								e.preventDefault(); props.changeSection(props.sections.list.main);
							}}
							className={classname({
								...className, 'active': props.sections.list.main === props.sections.active})
							}
							>
								{intl('Основное')}
							</a>

							{isAdditionalTabsHidden ? null : (
								<a href="#" onClick={e => {
									e.preventDefault(); props.changeSection(props.sections.list.postback);
								}}
								className={classname({
									...className,
									'active': props.sections.list.postback === props.sections.active})
								}>
									{intl('Постбэк')}
								</a>)
							}

							{ needPostbackLog && (
								<a href="#" onClick={e => {
									e.preventDefault(); props.changeSection(props.sections.list.postbacklog);
								}}
								className={classname({
									...className,
									'active': props.sections.list.postbacklog === props.sections.active})
								}
								>
									{intl('Постбэк лог')}
								</a>
							) }

							{isAdditionalTabsHidden ? null : (
								<a href="#" onClick={e => {
									e.preventDefault(); props.changeSection(props.sections.list.additional);
								}}
								className={classname({
									...className,
									'active': props.sections.list.additional === props.sections.active})
								}
								>
									{intl('Дополнительное')}
								</a>)
							}

						</div>
					</div>
				</div>
				<StreamForm
					{...props}
					enableReinitialize={true}
					initialValues={props.formData.fields}
					keepDirtyOnReinitialize={true}
					persistentSubmitErrors={false}
					intl={intl}
				/>
			</div>
		</div>);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		lists: selectors.getLists(state),
		progressBar: selectors.getProgressBar(state),
		geo_rules: selectors.getGeoRules(state),
		isRulesPopupVisible: state.stream.isRulesPopupVisible,
		isSaveLoader: selectors.getSaveLoader(state),
		langSelected: selectors.getFormSelectedLang(state),
		isShowMoreVisible: selectors.getShowMoreVisibility(state),
		selectedLandings: selectors.getSelectedLandings(state),
		sections: selectors.getSections(state),
		selectOptions: selectors.getSelectOptions(state),
		tableData: selectors.getTableData(state),
		formData: selectors.getFormData(state),
		landingSnippets: selectors.getLandingSnippets(state),
		isEditMode: selectors.isEditMode(state),
		canEdit: selectors.canEdit(state),
		isNewOrEditingActiveCampaign: selectors.isNewOrEditingActiveCampaign(state),
		isOtherAdv: selectors.isOtherAdv(state),
		isMyTargetAdv: selectors.isMyTargetAdv(state),
		shouldShowStatus: selectors.getShouldShowStatus(state),
		postBackLogData: selectors.getPostBackLog(state),
		calendar: selectors.getPostbackListCalendar(state),
		postbackSearch: selectors.getPostbackSearch(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		domainTooltipStatus: selectors.getDomainTooltipStatus(state),
		shouldShowSplitTooltip: selectors.getSplitSessionTooltipStatus(state),
		offerGeoStats: selectors.getOfferGeoStats(state),
		selectedCurrency: selectors.getSelectedCurrency(state),
		landingTransitHeaders: selectors.getLandingTransitHeaders(state),
		columnSorting: selectors.getColumnSorting(state),
		userBoostInfo: selectors.getUserBoostInfo(state),
		selectedOffer: selectors.getSelectedOfferData(state),
		popupsAvailability: selectors.getPopupsAvailability(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state),
		user: selectors.getUserData(state),
		chain: selectors.getCurrentChain(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/single/main.js